<div class="card-body">
  <ul class="d-flex flex-nowrap tab-bar">
    <li [routerLinkActive]="['active-tab']">
      <span routerLink="/super-admin/user-management/previleges-list">List all privileges granted to roles</span>
    </li>
    <li [routerLinkActive]="['active-tab']"><span routerLink="/super-admin/user-management/manage-users">User Management</span></li>
    <!-- <li [routerLinkActive]="['active-tab']"><span routerLink="/super-admin/user-management/user-role-report">Report</span></li> -->
  </ul>
  <router-outlet #outlet="outlet"></router-outlet>
</div>
